import md5 from 'md5';

export function generateId(type: 'relay' | 'tank' | 'tank-type'): string {
    return md5(`${type}-${Date.now()}-${Math.random()}`);
}
